var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C14.2091 0 16 1.79086 16 4V12C16 14.2091 14.2091 16 12 16H4C1.79086 16 0 14.2091 0 12V4C0 1.79086 1.79086 0 4 0H12ZM6.18457 10.3926L3.77832 7.98633L2.64746 9.11816L6.18457 12.6553L13.5371 5.30176L12.4062 4.1709L6.18457 10.3926Z",
    fill: "#5921F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxFilled);
export default __webpack_public_path__ + "static/media/CheckboxFilled.578da4ea6e7aa1eaa4a3a447fb8e9b75.svg";
export { ForwardRef as ReactComponent };